"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";

interface ModalContextType {
  isReferralModalVisible: boolean;
  showReferralModal: () => void;
  hideReferralModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isReferralModalVisible, setIsReferralModalVisible] = useState(false);

  const showReferralModal = () => {
    setIsReferralModalVisible(true);
  };

  const hideReferralModal = () => {
    setIsReferralModalVisible(false);
  };

  return (
    <ModalContext.Provider
      value={{
        isReferralModalVisible,
        showReferralModal,
        hideReferralModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};
